import { parsePhoneNumberFromString } from "libphonenumber-js";

/**
 * Validates an international phone number.
 * - Numbers with "+" are validated for any country
 * - Numbers without "+" are treated as defaultCountry (IN by default)
 *
 * @param {string} phone - raw phone input
 * @param {string} [defaultCountry="IN"] - default region when no country code
 * @returns {{ valid: boolean, error: string, e164: string|null }}
 */
export function validatePhoneNumber(phone, defaultCountry = "IN") {
  if (!phone || !String(phone).trim()) {
    return {
      valid: false,
      error: "*This field is required",
      e164: null,
    };
  }

  try {
    const trimmed = String(phone).trim();
    const phoneNumber = parsePhoneNumberFromString(trimmed, defaultCountry);

    if (!phoneNumber || !phoneNumber.isValid()) {
      return {
        valid: false,
        error:
          "*Enter a valid phone number with country code e.g. +919876543210",
        e164: null,
      };
    }

    return {
      valid: true,
      error: "",
      e164: phoneNumber.format("E.164"),
    };
  } catch (e) {
    return {
      valid: false,
      error: "*Enter a valid phone number with country code e.g. +919876543210",
      e164: null,
    };
  }
}

/**
 * Returns E.164 formatted number if possible, otherwise original input.
 * @param {string} phone
 * @param {string} [defaultCountry="IN"]
 * @returns {string}
 */
export function formatPhoneToE164(phone, defaultCountry = "IN") {
  const result = validatePhoneNumber(phone, defaultCountry);
  return result.valid ? result.e164 : phone;
}

export default validatePhoneNumber;
